import createStore from 'unistore';

const initStats = {
  gamesPlayed: 0,
  winPercent: 0,
  streak: 0,
  maxStreak: 0,
  guessDistribution: [0, 0, 0, 0, 0, 0],
  timeLastPlayed: ""
}

const initData = {
  word: "",
  letterStatus: {
    absent: new Set(),
    correct: new Set(),
    present: new Set()
  }
}

export const store = createStore({
  modal: {
    show: false,
    // possible types: info, win, stats
    type: "info"
  },
  toast: {
    show: false,
    // possible types: win, loss
    type: "win"
  },
  stats: initStats,
  data: initData
});

export const actions = store => ({
  showModal: ({ modal }, show, type) => ({ modal: { ...modal, show, type: type || modal.type } }),
  showToast: ({ toast }, show, type) => ({ toast: { ...toast, show, type: type || toast.type } }),
  logModal: ({ modal }) => console.log(modal),
  changeModalType: ({ modal }) => ({ modal: { ...modal, type: type || modal.type } }),
  updateStats: ({ stats }, toUpdate) => ({ stats: { ...stats, ...toUpdate } }),
  updateData: ({ data }, toUpdate) => ({ data: { ...data, ...toUpdate } }),
  resetData: ({ data }) => ({ data: { ...initData } }),
  addAbsent: ({ data }, abs) => ({ data: { ...data, letterStatus: { ...data.letterStatus, absent: [...data.letterStatus.absent, abs] } } }),
  addLetter: ({ data }, type, letter) => ({ data: { ...data, letterStatus: { ...data.letterStatus, [type]: data.letterStatus[type].add(letter) } } }),
  setWord: ({ data }, word) => ({ data: { ...data, word } })
})